import { Button, Center, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text, VStack, Image } from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import useModelAnexoChamada from './useModelAnexoChamada';
import { FaPaperclip } from 'react-icons/fa';
import { FaRegTrashAlt } from 'react-icons/fa';
import Simulacao from '../../../../../../images/modalPsicologo.svg';

function ModalAnexoChamada(props) {
  const disclosure = props.disclosure;
  const agenda_exames_id = props?.agenda_exames_id;
  const preatendimento = props?.preatendimento || false;
  const { theme, selectedFiles, handleFileChange, handleExcludeFile, handleSubmitFiles, errorSubmit, loading } = useModelAnexoChamada({
    agenda_exames_id,
    disclosure,
  });

  const inputRef = useRef(null);

  const handleButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent maxW="95%" h="auto" borderRadius="0.8em">
          <ModalCloseButton mt={1} color={'#9E9E9E'} onClick={() => disclosure.onClose()} _focus={false} />
          <ModalBody>
            <VStack p={6} spacing={5}>
              {preatendimento ? (
                <Image src={Simulacao} mt={2} w="55%" />
              ) : (
                <Center w="80px" h="80px" borderRadius="full" bg="gray.100">
                  <FaPaperclip color={theme.background} size={28} />
                </Center>
              )}

              <Text color="gray.600" fontWeight="medium" textAlign="center" fontSize="1rem" maxW="90%">
                {preatendimento
                  ? 'Envie os arquivos que deseja que seu médico avalie antes da consulta. Assim ele pode se preparar melhor para seu atendimento.'
                  : 'Selecione os arquivos que deseja enviar para seu médico.'}
              </Text>

              <input type="file" multiple ref={inputRef} style={{ display: 'none' }} onChange={handleFileChange} />

              <Button
                leftIcon={<FaPaperclip size={16} />}
                bg={theme.background}
                color="white"
                _hover={{ opacity: 0.9 }}
                borderRadius="12px"
                w="100%"
                size="md"
                onClick={handleButtonClick}
              >
                Selecionar arquivos
              </Button>

              {selectedFiles?.length > 0 && (
                <VStack w="100%" spacing={3} mt={2}>
                  {selectedFiles.map((file, index) => (
                    <HStack key={index} w="100%" justify="space-between" p={3} bg="gray.50" borderRadius="12px" border="1px solid #E2E8F0">
                      <Text fontSize="0.9rem" color="gray.700" noOfLines={1} maxW="80%">
                        {file.name}
                      </Text>

                      <FaRegTrashAlt cursor="pointer" color="#E53E3E" size={18} onClick={() => handleExcludeFile(index)} />
                    </HStack>
                  ))}
                </VStack>
              )}
            </VStack>

            {selectedFiles?.length > 0 && (
              <>
                {errorSubmit && (
                  <Text fontWeight="medium" fontSize="0.9rem" color="red.500" textAlign="center" mt={2}>
                    {errorSubmit}
                  </Text>
                )}

                <Center mt={4} mb={2}>
                  <Button
                    bg={theme.background}
                    color="white"
                    _hover={{ opacity: 0.9 }}
                    borderRadius="12px"
                    w="100%"
                    size="lg"
                    onClick={handleSubmitFiles}
                    isLoading={loading}
                  >
                    {loading ? 'Enviando...' : 'Enviar arquivos'}
                  </Button>
                </Center>
              </>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalAnexoChamada;
